import { createContext, useContext } from "react";
import type { ManagedUser } from "./types";

/**
 * Same shape as TrialActionsContext, and for the same reason: the row action
 * lives four components below the state it needs, and threading an optional
 * callback through DirectoryCard, UserTable and UserTableRow buys nothing.
 */
export type SupportLoginActions = {
  onSupportLogin: (user: ManagedUser) => void;
};

const SupportLoginActionsContext = createContext<SupportLoginActions | null>(
  null,
);

export const SupportLoginActionsProvider =
  SupportLoginActionsContext.Provider;

export const useSupportLoginActions = () =>
  useContext(SupportLoginActionsContext);
